import React from 'react'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { getPlural } from 'lib/string/pluralize'

type Props = {
  order: App.Order
  showOrderId?: boolean
  orderItemType: 'offer' | 'tour'
}

const BookingIdConfirmation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

function BookingsDetails(props: Props) {
  const { order, showOrderId = true, orderItemType } = props

  let bookingIds: Array<string>
  if (orderItemType === 'tour') {
    bookingIds = order.tourItems.map((item) => item.bookingId) ?? []
  } else {
    bookingIds = order.items.map((item) => item.bookingNumber) ?? []
  }

  return (
    <>
      <Heading variant="heading5">Your Booking Details</Heading>
      {showOrderId && (
        <BookingIdConfirmation>
          <div>
            <BodyText variant="medium" weight="bold">
              {getPlural('Booking ID', bookingIds.length)}
            </BodyText>
            <BodyText variant="large">{bookingIds.join(', ')}</BodyText>
          </div>
        </BookingIdConfirmation>
      )}
      <div>
        <BodyText variant="medium" weight="bold">
          Total Paid
        </BodyText>
        <BodyText variant="large">${order.total}</BodyText>
      </div>
    </>
  )
}

export default BookingsDetails
